import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		Provozovna: [],
	},
	filter: {
		ProvozovnaId: null as number | null,
		PracovnikId: null as number | null,
		PracovnikIdText: null as string | null,
		PracovnikOsobniCis: null as string | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[types.mutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.filter.PracovnikId = data.value;
			state.filter.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.PracovnikOsobniCis = data.osobniCis;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
